import { cn } from '@/lib/utils'
import { Slot } from '@radix-ui/react-slot'
import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

const buttonVariants = cva('items-center justify-center whitespace-nowrap rounded-full font-[300] text-black ', {
	defaultVariants: {
		size: 'default',
		text: 'default',
		variant: 'default',
	},
	variants: {
		size: {
			default: 'px-5 py-3',
			sm: 'h-9 px-3',
			md: 'px-9 py-3',
		},
		text: {
			base: 'text-base',
			default: 'text-lg',
			md: 'text-md',
			sm: 'text-sm',
		},
		variant: {
			default:
				'shadow-md  hover:-translate-y-1 transform transition  hover:shadow-lg bg-[linear-gradient(110deg,#cbadca,45%,#d59fd3,55%,#cbadca)] hover:text-white hover:bg-[linear-gradient(110deg,#A56AAB,45%,#d59fd3,55%,#A56AAB)] bg-[length:200%_100%] animate-shimmer',
			none: '',
			signin: 'bg-[#A56AAB] w-full rounded-2xl  py-1 font-patrick text-white ',
		},
	},
})

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
	asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ asChild = false, className, size, variant, ...props }, ref) => {
	const Comp = asChild ? Slot : 'button'
	return <Comp className={cn(buttonVariants({ className, size, variant }))} ref={ref} {...props} />
})
Button.displayName = 'Button'

export { Button, buttonVariants }
